import React, { useEffect, useState } from 'react';
import { Form, Col, Row, Button } from 'react-bootstrap';
import { jwtDecode } from 'jwt-decode';
import { Associations } from '../../utils/Elements/Associations';

import './AccountPage.css';

export const AccountPage = () => {
  const[account, setAccount] = useState({
    ID: '',
    UID: '',
    Username: '',
    EmployeeFirstName: '',
    EmployeeLastName: '',
    EmployeeEmail: '',
    DirectPhone: '',
    EmployeeType: '',
    OrderMasterOverride: false
  });
  const api = process.env.REACT_APP_API_ENDPOINT
  const employeeAccount = `${api}/v1/employees`
  const employeeAssociation = `${api}/v1/associations/account/`
  const getStoredToken = () => {
    return localStorage.getItem('token');
  };
  const storedToken = getStoredToken();
  const getEmployeeAccount = async () => {
    const identity = jwtDecode(storedToken);
    try {
      const response = await fetch(employeeAccount, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json',
          'EmployeeUID': identity.sub,
        }
    });
    if (response.ok) {
      const data = await response.json();
      setAccount(data);
    } else {
      console.log("error");
    }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getEmployeeAccount();
  }, [storedToken]);

  return (
    <>
      <div className='container'>
        <Row>

          <Col className='login-container' md="6">

              <Row className='mb-3'>
                <Form.Group as={Col} md="12" controlId="name">
                  <Form.Label>Name</Form.Label>
                  <Form.Control name='name' type="text" placeholder="Name" value={`${account.EmployeeFirstName} ${account.EmployeeLastName}`}  disabled />

                </Form.Group>
              </Row>
              <Row className='mb-3'>
                <Form.Group as={Col} md="12" controlId="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control name='email' type="text" placeholder="Email" value={account.EmployeeEmail} disabled />
                </Form.Group>
              </Row>
              <Row className='mb-3'>
                <Form.Group as={Col} md="12" controlId="phone">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control name='phone' type="text" placeholder="Phone" value={account.DirectPhone} disabled />
                </Form.Group>
              </Row>
              <Row className='mb-3'>
                <div className='d-flex flex-row'>
                  <Associations
                    associationsEndpoint={employeeAssociation}
                  />
                </div>
              </Row>
              {/*<Row className='mb-3'>
                <div class="d-flex flex-row-reverse">
                   <Col md="6">
                    <Button className="forgot-password remove-filter-link" onClick={forgotPassword}>Forgot password?</Button>
                  </Col>
                  <Col md="6" className='align-self-end'>
                    <Button variant="login" type="submit" disabled>
                      Update
                    </Button>
                  </Col>
                </div>
              </Row>*/}

          </Col>

        </Row>
      </div>
    </>
  )
};